import iconReact from './assets/icons/icon-react.png'
import iconHtml from './assets/icons/icon-html.png'
import iconJs from './assets/icons/icon-js.png'
import iconCss from './assets/icons/css-icon.webp'
import iconVue from './assets/icons/vue.webp'
import iconInnertia from './assets/icons/innertia.svg'
import iconAdobe from './assets/icons/adobe.webp'
import iconTailwind from './assets/icons/tailwinf.png'
import iconVite from './assets/icons/vite.png'
import iconPhp from './assets/icons/php.png'

import Gif1 from './assets/gifs/bubbleGif-john.gif'
import Gif2 from './assets/gifs/gifs1.gif'
import ExImg1 from './assets/sliders/Slide1.png'
import ExImg2 from './assets/sliders/Slide2.png'
import ExImg3 from './assets/sliders/Slide3.png'
import ExImg5 from './assets/sliders/juego2.png'
import ExImg6 from './assets/sliders/juego3.png'
import ExImg7 from './assets/sliders/juego4.png'
import ExImg8 from './assets/sliders/juego5.png'
import ExImg9 from './assets/sliders/juego6.png'
import ExImg10 from './assets/sliders/juego7.png'
import ExImg11 from './assets/sliders/Alzheimer.png'
import ExImg12 from './assets/sliders/Alzheimer1.png'
import ExImg13 from './assets/sliders/Alzheimer2.png'
import ExImg14 from './assets/sliders/Alzheimer3.png'
import ExImg15 from './assets/sliders/Alzheimer4.png'
import Gif3 from './assets/gifs/gifs2.gif'
import Gif4 from './assets/gifs/gifs3.gif'
import ExImg16 from './assets/sliders/quiere1.png'
import ExImg17 from './assets/sliders/quiere2.png'
import ExImg18 from './assets/sliders/quiere3.png'
import ExImg19 from './assets/sliders/quiere4.png'
import ExImg20 from './assets/sliders/quiere5.png'
import Gif5 from './assets/gifs/gifs4.gif'
import ExImg21 from './assets/sliders/sante1.png'
import ExImg22 from './assets/sliders/sante2.png'
import ExImg23 from './assets/sliders/sante3.png'
import ExImg24 from './assets/sliders/sante4.png'
import Gif6 from './assets/gifs/gifs5.gif'
import ExImg25 from './assets/sliders/recor1.png'
import ExImg26 from './assets/sliders/recor2.png'
import ExImg27 from './assets/sliders/recor3.png'
import ExImg28 from './assets/sliders/recor4.png'
import ExImg29 from './assets/sliders/recor5.png'
import ExImg30 from './assets/sliders/recor6.png'
import Gif7 from './assets/gifs/gifs6.gif'
import ExImg31 from './assets/sliders/aspen1.png'
import ExImg32 from './assets/sliders/aspen2.png'
import ExImg33 from './assets/sliders/aspen3.png'
import Gif8 from './assets/gifs/gifs7.gif'
import ExImg34 from './assets/sliders/reblo1.png'
import ExImg35 from './assets/sliders/reblo2.png'
import ExImg36 from './assets/sliders/reblo3.png'
import Gif9 from './assets/gifs/gifs8.gif'
import ExImg37 from './assets/sliders/conexion1.png'
import ExImg38 from './assets/sliders/conexion2.png'
import ExImg39 from './assets/sliders/conexion3.png'
import ExImg40 from './assets/sliders/conexion4.png'
import ExImg41 from './assets/sliders/conexion5.png'
import ExImg42 from './assets/sliders/conexion6.png'
import Gif10 from './assets/gifs/gifs9.gif'
import ExImg43 from './assets/sliders/ente1.png'
import ExImg44 from './assets/sliders/ente2.png'
import ExImg45 from './assets/sliders/ente3.png'
import ExImg46 from './assets/sliders/ente4.png'
import ExImg47 from './assets/sliders/ente5.png'
import Gif11 from './assets/gifs/gifs10.gif'
import ExImg48 from './assets/sliders/land1.png'
import ExImg49 from './assets/sliders/land2.png'
import ExImg50 from './assets/sliders/land3.png'
import ExImg51 from './assets/sliders/land4.png'
import Gif12 from './assets/gifs/gifs11.gif'
import ExImg52 from './assets/sliders/merc1.png'
import ExImg53 from './assets/sliders/merc2.png'
import ExImg54 from './assets/sliders/merc3.png'
import ExImg55 from './assets/sliders/merc4.png'
import Gif13 from './assets/gifs/gifs12.gif'
import ExImg56 from './assets/sliders/MUCO1.png'
import ExImg57 from './assets/sliders/MUCO2.png'
import ExImg58 from './assets/sliders/MUCO3.png'
import ExImg59 from './assets/sliders/MUCO4.png'
import Gif14 from './assets/gifs/gifs13.gif'
import ExImg60 from './assets/sliders/grupo1.png'
import ExImg61 from './assets/sliders/grupo2.png'
import ExImg62 from './assets/sliders/grupo3.png'
import Gif15 from './assets/gifs/gifs14.gif'
import ExImg63 from './assets/sliders/bac1.png'
import ExImg64 from './assets/sliders/bac2.png'
import ExImg65 from './assets/sliders/bac3.png'
import ExImg66 from './assets/sliders/bac4.png'
import Gif16 from './assets/gifs/gifs15.gif'
import ExImg67 from './assets/sliders/eu1.png'
import ExImg68 from './assets/sliders/eu2.png'
import Gif17 from './assets/gifs/gifs16.gif'
import ExImg69 from './assets/sliders/revi1.png'
import ExImg70 from './assets/sliders/revi2.png'
import ExImg71 from './assets/sliders/revi3.png'
import ExImg72 from './assets/sliders/revi4.png'
import Gif18 from './assets/gifs/gifs17.gif'
import ExImg73 from './assets/sliders/ruleta.png'
import Gif19 from './assets/gifs/gifs18.gif'
import ExImg74 from './assets/sliders/bio1.png'
import ExImg75 from './assets/sliders/bio2.png'
import ExImg76 from './assets/sliders/bio3.png'
import Gif20 from './assets/gifs/gifs19.gif'
import ExImg77 from './assets/sliders/slider23.png'
import ExImg78 from './assets/sliders/slider24.png'
import Gif21 from './assets/gifs/gifs20.gif'
import ExImg79 from './assets/sliders/dash1.png'
import Gif22 from './assets/gifs/gifs21.gif'
import ExImg80 from './assets/sliders/calc1.png'
import ExImg81 from './assets/sliders/calc2.png'
import ExImg82 from './assets/sliders/calc3.png'
import Gif23 from './assets/gifs/gifs22.gif'
import ExImg83 from './assets/sliders/jueg1.png'
import ExImg84 from './assets/sliders/jueg2.png'
import ExImg85 from './assets/sliders/jueg3.png'
import Gif24 from './assets/gifs/gifs23.gif'
import ExImg86 from './assets/sliders/cho1.png'
import ExImg87 from './assets/sliders/cho2.png'
import ExImg88 from './assets/sliders/cho3.png'
import Gif25 from './assets/gifs/gifs24.gif'
import ExImg89 from './assets/sliders/baby1.png'
import ExImg90 from './assets/sliders/baby2.png'
import ExImg91 from './assets/sliders/baby3.png'
import Gif26 from './assets/gifs/gifs25.gif'
import ExImg92 from './assets/sliders/nutri1.png'
import ExImg93 from './assets/sliders/nutri2.png'
import ExImg94 from './assets/sliders/nutri3.png'
import Gif27 from './assets/gifs/gifs26.gif'
import ExImg95 from './assets/sliders/sybr1.png'
import ExImg96 from './assets/sliders/sybr2.png'
import ExImg97 from './assets/sliders/sybr3.png'
import Gif28 from './assets/gifs/gifs27.gif'
import ExImg98 from './assets/sliders/REVIS1.png'
import ExImg99 from './assets/sliders/REVIS2.png'
import ExImg100 from './assets/sliders/REVIS3.png'
import ExImg101 from './assets/sliders/REVIS4.png'
import Gif29 from './assets/gifs/gifs28.gif'
import ExImg102 from './assets/sliders/io1.png'
import ExImg103 from './assets/sliders/io2.png'
import ExImg104 from './assets/sliders/io3.png'
import ExImg105 from './assets/sliders/io4.png'
import Gif30 from './assets/gifs/gifs29.gif'
import ExImg106 from './assets/sliders/pareja.png'
import Gif31 from './assets/gifs/gifs30.gif'
import ExImg107 from './assets/sliders/nmu1.png'
import ExImg108 from './assets/sliders/nmu2.png'
import ExImg109 from './assets/sliders/nmu3.png'
import Gif32 from './assets/gifs/gifs31.gif'
import ExImg110 from './assets/sliders/rule1.png'
import ExImg111 from './assets/sliders/rule2.png'
import ExImg112 from './assets/sliders/rule3.png'
import Gif33 from './assets/gifs/gifs32.gif'
import ExImg113 from './assets/sliders/MICRO1.png'
import ExImg114 from './assets/sliders/MICRO2.png'
import ExImg115 from './assets/sliders/MICRO3.png'
import Gif34 from './assets/gifs/gifs33.gif'
import ExImg116 from './assets/sliders/prazis1.png'
import ExImg117 from './assets/sliders/prazis2.png'
import Gif35 from './assets/gifs/gifs34.gif'
import ExImg118 from './assets/sliders/movil1.png'
import ExImg119 from './assets/sliders/movil2.png'
import ExImg120 from './assets/sliders/movil3.png'
import Gif36 from './assets/gifs/gifs35.gif'
import ExImg121 from './assets/sliders/penal2.png'
import ExImg122 from './assets/sliders/penal3.png'
import ExImg123 from './assets/sliders/penal1.png'
import Gif37 from './assets/gifs/gifs36.gif'
import ExImg124 from './assets/sliders/sospechar.png'
import ExImg125 from './assets/sliders/sospechar1.png'
import Gif38 from './assets/gifs/gifs37.gif'
import ExImg126 from './assets/sliders/banner.png'
import Gif39 from './assets/gifs/gifs38.gif'
import ExImg127 from './assets/sliders/paralela.png'
import Gif40 from './assets/gifs/gifs39.gif'
import ExImg128 from './assets/sliders/banenr ia.png'
import Gif41 from './assets/gifs/gifs40.gif'
import ExImg129 from './assets/sliders/banneria1.png'



export const languageIcons = {
    'React': iconReact,
    'HTML': iconHtml,
    'HTML5': iconHtml,
    'JS': iconJs,
    'JavaScript': iconJs,
    'CSS': iconCss,
    'CSS3': iconCss,
    'Vue': iconVue,
    'Innertia': iconInnertia,
    'Adobe': iconAdobe,
    'Adobe Acrobat': iconAdobe,
    'Tailwind CSS': iconTailwind,
    'Vite': iconVite,
    'Php': iconPhp,
};

export const dumiProjects = [{
        id: 1,
        name: 'Bubble Shooter EML',
        slug: '1',
        category: 'Videojuegos',
        description: 'Bubble shooter es un juego de lógica, en donde el objetivo es eliminar todas las burbujas de la pantalla apuntando hacia las burbujas en las cuales podamos crear grupos de 3 o más del mismo color, de esta forma, los grupos formados irán siendo derribados. Este juego puede contener características como: login y registro, conexión con base de datos para almacenamiento de puntajes por usuario, pop ups informativos, distribución por niveles, personalización de sprites (pueden ser otras figuras distintas a las burbujas), animaciones y sonidos.',
        images: [
            { type: 'video', url: Gif1 },
            { type: 'image', url: ExImg1 },
            { type: 'image', url: ExImg2 },
            { type: 'image', url: ExImg3 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['React', 'HTML', 'CSS', 'Tailwind CSS'],
        url: 'http://juegos-portafolio.eml.com.co/bubble-shooter/',
    },
    {
        id: 2,
        name: 'Concentrece Entero Dulco',
        slug: '2',
        category: 'Videojuegos',
        description: 'Es un “Concéntrese” interactivo donde el objetivo es encontrar parejas de cartas iguales usando la memoria. Ayuda a fortalecer la concentración, la atención y la agilidad mental, ya que el jugador debe recordar la ubicación de cada imagen para completar correctamente todas las parejas.',
        images: [
            { type: 'video', url: Gif2 },
            { type: 'image', url: ExImg5 },
            { type: 'image', url: ExImg6 },
            { type: 'image', url: ExImg6 },
            { type: 'image', url: ExImg7 },
            { type: 'image', url: ExImg8 },
            { type: 'image', url: ExImg9 },
            { type: 'image', url: ExImg10 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['HTML', 'CSS', 'JS'],
        url: 'https://eml.com.co/ConcentreseEnteroDulco/index.html',
    },
    {
        id: 3,
        name: 'Juego Alzheimer',
        slug: '3',
        category: 'Videojuegos',
        description: 'El juego “Alzheimer” es una actividad interactiva enfocada en estimular la memoria y las capacidades cognitivas. A través de ejercicios de asociación y recordación, busca fortalecer la atención, la concentración y el entrenamiento mental de una forma dinámica y entretenida.',
        images: [
            { type: 'video', url: Gif3 },
            { type: 'image', url: ExImg11 },
            { type: 'image', url: ExImg12 },
            { type: 'image', url: ExImg13 },
            { type: 'image', url: ExImg14 },
            { type: 'image', url: ExImg15 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['HTML', 'CSS', 'JS'],
        url: 'https://www.emlproyectos.com.co/Alzheimer/index.html',
    },
    {
        id: 4,
        name: 'Quien Quiere ser millonario',
        slug: '4',
        category: 'Videojuegos',
        description: 'El juego “¿Quién Quiere Ser Millonario?” es una actividad interactiva de preguntas y respuestas inspirada en el famoso concurso de televisión. El objetivo es responder correctamente diferentes preguntas para avanzar de nivel, poniendo a prueba los conocimientos, la memoria y la agilidad mental del jugador.',
        images: [
            { type: 'video', url: Gif4 },
            { type: 'image', url: ExImg16 },
            { type: 'image', url: ExImg17 },
            { type: 'image', url: ExImg18 },
            { type: 'image', url: ExImg19 },
            { type: 'image', url: ExImg20 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['HTML', 'CSS', 'JS'],
        url: 'https://eml.com.co/QuienQuiereSerMillomarioEroxom/index.html',
    },
    {
        id: 5,
        name: 'Juego Vitamina C',
        slug: '5',
        category: 'Videojuegos',
        description: 'El juego “Vitamina C” es una actividad interactiva educativa enfocada en el aprendizaje y la asociación de conceptos relacionados con la salud y la nutrición. A través de dinámicas visuales y participativas, busca fortalecer la atención, la memoria y el aprendizaje de manera entretenida.',
        images: [
            { type: 'video', url: Gif5 },
            { type: 'image', url: ExImg21 },
            { type: 'image', url: ExImg22 },
            { type: 'image', url: ExImg23 },
            { type: 'image', url: ExImg24 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['HTML', 'CSS', 'JS'],
        url: 'https://eml.com.co/vitamina-C/index.html',
    },
    {
        id: 6,
        name: 'Quien quiere jugar Recordando',
        slug: '6',
        category: 'Videojuegos',
        description: 'El juego “Vitamina C” es una actividad interactiva educativa enfocada en el aprendizaje y la asociación de conceptos relacionados con la salud y la nutrición. A través de dinámicas visuales y participativas, busca fortalecer la atención, la memoria y el aprendizaje de manera entretenida.',
        images: [
            { type: 'video', url: Gif6 },
            { type: 'image', url: ExImg25 },
            { type: 'image', url: ExImg26 },
            { type: 'image', url: ExImg27 },
            { type: 'image', url: ExImg28 },
            { type: 'image', url: ExImg29 },
            { type: 'image', url: ExImg30 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['HTML', 'CSS', 'JS'],
        url: 'https://eml.com.co/QuienQuiereJugarRecordando/index.html',
    },
    {
        id: 7,
        name: 'Concéntrese Aspen',
        slug: '7',
        category: 'Videojuegos',
        description: 'El juego “Concéntrese Aspen” es una actividad interactiva de memoria en la que el jugador debe encontrar parejas de imágenes iguales. Su objetivo es fortalecer la concentración, la atención y la memoria visual mediante una dinámica sencilla y entretenida.',
        images: [
            { type: 'video', url: Gif7 },
            { type: 'image', url: ExImg31 },
            { type: 'image', url: ExImg32 },
            { type: 'image', url: ExImg33 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['HTML', 'CSS', 'JS'],
        url: 'https://eml.com.co/concentreseAspen/index.html',
    },
    {
        id: 8,
        name: 'Concéntrese Reblozyl',
        slug: '8',
        category: 'Videojuegos',
        description: 'El juego “Concéntrese Reblozyl” es una actividad interactiva de memoria que consiste en encontrar parejas de imágenes iguales. Está diseñado para estimular la concentración, la atención y la memoria visual mediante una experiencia dinámica y entretenida.',
        images: [
            { type: 'video', url: Gif8 },
            { type: 'image', url: ExImg34 },
            { type: 'image', url: ExImg35 },
            { type: 'image', url: ExImg36 },

        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['HTML', 'CSS', 'JS'],
        url: 'https://eml.com.co/Concentrese-Reblozyl/index.html',
    },
    {
        id: 9,
        name: 'Conexión Procaps',
        slug: '9',
        category: 'Videojuegos',
        description: 'El juego “Conexión Procaps” es una actividad interactiva enfocada en la asociación y conexión de conceptos o elementos relacionados. Su objetivo es fortalecer la memoria, la concentración y la agilidad mental mediante dinámicas visuales y de relación.',
        images: [
            { type: 'video', url: Gif9 },
            { type: 'image', url: ExImg37 },
            { type: 'image', url: ExImg38 },
            { type: 'image', url: ExImg39 },
            { type: 'image', url: ExImg40 },
            { type: 'image', url: ExImg41 },
            { type: 'image', url: ExImg42 },

        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['HTML', 'CSS', 'JS'],
        url: 'https://eml.com.co/conexion-procaps/index.html',
    },
    {
        id: 10,
        name: 'Stand Congreso',
        slug: '10',
        category: 'Videojuegos',
        description: 'El juego “Stand Congreso” es una experiencia interactiva diseñada para eventos o congresos, donde los participantes pueden interactuar con diferentes dinámicas digitales de forma entretenida. Su objetivo es promover la participación, la atención y el aprendizaje mediante actividades visuales e interactivas.',
        images: [
            { type: 'video', url: Gif10 },
            { type: 'image', url: ExImg43 },
            { type: 'image', url: ExImg44 },
            { type: 'image', url: ExImg45 },
            { type: 'image', url: ExImg46 },
            { type: 'image', url: ExImg47 },

        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['HTML', 'CSS', 'Vue'],
        url: 'https://eml.com.co/standCongreso/',
    },
    {
        id: 11,
        name: 'PINT Academy',
        slug: '11',
        category: 'Desarrollos web',
        description: 'La página PINT Academyes una plataforma educativa digital enfocada en contenido científico y académico relacionado con la medicina y diferentes áreas terapéuticas. Su objetivo es brindar formación, actualización y acceso a recursos educativos para profesionales de la salud mediante una experiencia interactiva y organizada.',
        images: [
            { type: 'video', url: Gif11 },
            { type: 'image', url: ExImg48 },
            { type: 'image', url: ExImg49 },
            { type: 'image', url: ExImg50 },
            { type: 'image', url: ExImg51 },

        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['HTML', 'CSS', 'Innertia'],
        url: 'https://pintacademy.com/es',
    },
    {
        id: 12,
        name: 'Casa de Merck',
        slug: '12',
        category: 'Desarrollos web',
        description: 'Merck enfocada en contenido médico y científico. Está diseñada para presentar información interactiva relacionada con tratamientos, estudios clínicos o materiales educativos dirigidos a profesionales de la salud.',
        images: [
            { type: 'video', url: Gif12 },
            { type: 'image', url: ExImg52 },
            { type: 'image', url: ExImg53 },
            { type: 'image', url: ExImg54 },
            { type: 'image', url: ExImg55 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['HTML', 'React', 'Tailwind CSS'],
        url: 'https://merck.casadaem.com.ec/',
    },
    {
        id: 13,
        name: 'Mucosolvan',
        slug: '13',
        category: 'Videojuegos',
        description: 'El juego “Reto Mucosolvan” es una actividad interactiva enfocada en el manejo de la tos y la salud respiratoria. A través de dinámicas visuales y de entretenimiento, el jugador participa en retos relacionados con la eliminación de secreciones y el cuidado pulmonar, promoviendo de forma educativa y didáctica los beneficios del producto Mucosolvan.',
        images: [
            { type: 'video', url: Gif13 },
            { type: 'image', url: ExImg56 },
            { type: 'image', url: ExImg57 },
            { type: 'image', url: ExImg58 },
            { type: 'image', url: ExImg59 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['HTML', 'CSS', 'JS'],
        url: 'https://eml.com.co/reto_mucosolvan/CostaRica/index01-CR.html',
    },
    {
        id: 14,
        name: 'Grupo Amarey',
        slug: '14',
        category: 'Desarrollos web',
        description: 'Bubble shooter es un juego de lógica, en donde el objetivo es eliminar todas las burbujas de la pantalla apuntando hacia las burbujas en las cuales podamos crear grupos de 3 o más del mismo color, de esta forma, los grupos formados irán siendo derribados. Este juego puede contener características como: login y registro, conexión con base de datos para almacenamiento de puntajes por usuario, pop ups informativos, distribución por niveles, personalización de sprites (pueden ser otras figuras distintas a las burbujas), animaciones y sonidos.',
        images: [
            { type: 'video', url: Gif14 },
            { type: 'image', url: ExImg60 },
            { type: 'image', url: ExImg61 },
            { type: 'image', url: ExImg62 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['React', 'HTML', 'CSS', 'Tailwind CSS'],
        url: 'https://www.grupoamarey.com/',
    },
    {
        id: 15,
        name: 'Desequilibrio bacteriano',
        slug: '15',
        category: 'Desarrollos web',
        description: 'Enterogermina E-Books corresponde a una plataforma o recurso digital interactivo enfocado en contenido educativo y científico relacionado con Enterogermina. Su objetivo es presentar información médica, estudios y materiales de consulta en formato visual y digital para profesionales de la salud.',
        images: [
            { type: 'video', url: Gif15 },
            { type: 'image', url: ExImg63 },
            { type: 'image', url: ExImg64 },
            { type: 'image', url: ExImg65 },
            { type: 'image', url: ExImg66 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['HTML', 'CSS', 'JS'],
        url: 'https://emlproyectos.com.co/Enterogermina_E-Books/index01.html',
    },
    {
        id: 16,
        name: 'Eucerin',
        slug: '16',
        category: 'Desarrollos web',
        description: 'Enterogermina E-Books corresponde a una plataforma o recurso digital interactivo enfocado en contenido educativo y científico relacionado con Enterogermina. Su objetivo es presentar información médica, estudios y materiales de consulta en formato visual y digital para profesionales de la salud.',
        images: [
            { type: 'video', url: Gif16 },
            { type: 'image', url: ExImg67 },
            { type: 'image', url: ExImg68 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['React', 'Tailwind CSS'],
        url: 'https://eucerin-elearning.eml.com.co/',
    },
    {
        id: 17,
        name: 'Revista digital',
        slug: '17',
        category: 'Desarrollos web',
        description: 'La página “Propuesta de Valor Bristol” corresponde a una ayuda visual o presentación interactiva diseñada para comunicar la propuesta de valor de Bristol Myers Squibb. El contenido muestra información estratégica, beneficios, soluciones y elementos diferenciales de la compañía mediante una experiencia visual e interactiva dirigida a profesionales de la salud o equipos comerciales.',
        images: [
            { type: 'video', url: Gif17 },
            { type: 'image', url: ExImg69 },
            { type: 'image', url: ExImg70 },
            { type: 'image', url: ExImg71 },
            { type: 'image', url: ExImg72 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['HTML', 'CSS', 'JS'],
        url: 'https://propuesta-de-valor-bristol.vercel.app/AV%20Propuesta%20de%20Valor%20Bristol.html',
    },
    {
        id: 18,
        name: 'Juego ruleta',
        slug: '18',
        category: 'Videojuegos',
        description: 'La “Ruleta Novalgina” es un juego interactivo tipo ruleta diseñado para actividades promocionales y dinámicas digitales. Su objetivo es entretener a los participantes mientras interactúan con contenido relacionado con Novalgina mediante premios, preguntas o retos visuales de forma dinámica y atractiva.',
        images: [
            { type: 'video', url: Gif18 },
            { type: 'image', url: ExImg73 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['HTML', 'CSS', 'JS'],
        url: 'https://eml.com.co/Ruletas/Ruleta_Novalgina/index.html',
    },
    {
        id: 19,
        name: 'Elearning Biomerieux',
        slug: '19',
        category: 'desarrollos web',
        description: 'Es una plataforma de e-learning o capacitación clínica en línea, enfocada en formación médica y farmacéutica. Permite a profesionales de la salud acceder a cursos, materiales interactivos, evaluaciones y contenidos educativos relacionados con productos, tratamientos y actualización científica.',
        images: [
            { type: 'video', url: Gif19 },
            { type: 'image', url: ExImg74 },
            { type: 'image', url: ExImg75 },
            { type: 'image', url: ExImg76 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['HTML', 'React', 'Tailwind CSS', 'Vite'],
        url: 'https://elearningclinicalbmxsystems.com/login',
    },
    {
        id: 20,
        name: 'Elearning Hemocultivos',
        slug: '20',
        category: 'desarrollos web',
        description: 'Es una plataforma de capacitación virtual especializada de BioMérieux, enfocada en formación clínica y diagnóstico médico. Incluye cursos interactivos, material científico, entrenamientos y recursos educativos dirigidos a profesionales de la salud, especialmente en áreas de microbiología, diagnóstico clínico y laboratorio.',
        images: [
            { type: 'video', url: Gif20 },
            { type: 'image', url: ExImg77 },
            { type: 'image', url: ExImg78 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['HTML', 'React', 'Tailwind CSS', 'Vite'],
        url: 'https://biomerieux.elearningclinicalbmxsystems.com/',
    },
    {
        id: 21,
        name: 'Dashboard Biomerieux',
        slug: '21',
        category: 'desarrollos web',
        description: 'Es una plataforma tipo dashboard administrativo utilizada para la gestión y seguimiento de equipos dentro del entorno de capacitación clínica de BMX Systems. Probablemente permite administrar usuarios, métricas, progreso de cursos, desempeño y acceso a contenidos educativos para equipos médicos o comerciales.',
        images: [
            { type: 'video', url: Gif21 },
            { type: 'image', url: ExImg79 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['HTML', 'React', 'Tailwind CSS', 'Vite'],
        url: 'https://dashboard-equipos.elearningclinicalbmxsystems.com/login',
    },
    {
        id: 22,
        name: 'Calculadora Mavenclad Merck',
        slug: '22',
        category: 'desarrollos web',
        description: 'Es una calculadora médica de MAVENCLAD® (cladribina), un medicamento usado para tratar ciertos tipos de Esclerosis múltiple.',
        images: [
            { type: 'video', url: Gif22 },
            { type: 'image', url: ExImg80 },
            { type: 'image', url: ExImg81 },
            { type: 'image', url: ExImg82 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['HTML', 'Php'],
        url: 'https://calculadora-mavenclad-version2.eml.com.co/Login.html',
    },
    {
        id: 23,
        name: 'Juego interactivo de Azitromicina',
        slug: '23',
        category: 'videojuegos',
        description: 'Juego interactivo de Azitromicina Elimina bacterias antes de que invadan el área y aprende sobre el uso correcto de antibióticos. Supera niveles, evita la resistencia bacteriana y gana puntos en cada misión.',
        images: [
            { type: 'video', url: Gif23 },
            { type: 'image', url: ExImg83 },
            { type: 'image', url: ExImg84 },
            { type: 'image', url: ExImg85 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['React', 'Vite', 'Tailwind CSS'],
        url: 'https://calculadora-mavenclad-version2.eml.com.co/Login.html',
    },
    {
        id: 24,
        name: 'Juego Colesterol Race',
        slug: '24',
        category: 'videojuegos',
        description: 'Reduce el LDL, aumenta el HDL y supera obstáculos en el torrente sanguíneo. Aprende sobre el control del colesterol mientras avanzas en cada nivel.',
        images: [
            { type: 'video', url: Gif24 },
            { type: 'image', url: ExImg86 },
            { type: 'image', url: ExImg87 },
            { type: 'image', url: ExImg88 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['React', 'Vite', 'Tailwind CSS'],
        url: 'https://calculadora-mavenclad-version2.eml.com.co/Login.html',
    },
    {
        id: 25,
        name: 'NutriBaby eLearning',
        slug: '25',
        category: 'desarrollos web',
        description: 'Plataforma interactiva de aprendizaje enfocada en nutrición y cuidado infantil, diseñada para brindar contenido educativo de manera dinámica y accesible.',
        images: [
            { type: 'video', url: Gif25 },
            { type: 'image', url: ExImg89 },
            { type: 'image', url: ExImg90 },
            { type: 'image', url: ExImg91 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['React', 'Vite', 'Tailwind CSS'],
        url: 'https://elearning-nutribaby.vercel.app/index.html',
    },
    {
        id: 26,
        name: 'Elearning MedPlus',
        slug: '26',
        category: 'desarrollos web',
        description: 'Plataforma digital orientada al sector salud que centraliza herramientas, contenido médico y recursos interactivos para apoyo educativo y profesional.',
        images: [
            { type: 'video', url: Gif26 },
            { type: 'image', url: ExImg92 },
            { type: 'image', url: ExImg93 },
            { type: 'image', url: ExImg94 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['React', 'Vite', 'Tailwind CSS'],
        url: 'https://medplus.eml.com.co/',
    },
    {
        id: 27,
        name: 'Elearning Sybrava',
        slug: '27',
        category: 'desarrollos web',
        description: 'Módulo interactivo de contenido educativo diseñado para presentar información médica de forma dinámica y estructurada.',
        images: [
            { type: 'video', url: Gif27 },
            { type: 'image', url: ExImg95 },
            { type: 'image', url: ExImg96 },
            { type: 'image', url: ExImg97 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['React', 'Vite', 'Tailwind CSS'],
        url: 'https://estructura-sesi-n-5-sybrava.vercel.app/',
    },
    {
        id: 28,
        name: 'Elearning Isavuconazol Interactive',
        slug: '28',
        category: 'desarrollos web',
        description: 'Experiencia interactiva enfocada en contenido farmacéutico y educativo sobre Isavuconazol, presentada mediante recursos visuales y navegación dinámica.',
        images: [
            { type: 'video', url: Gif28 },
            { type: 'image', url: ExImg98 },
            { type: 'image', url: ExImg99 },
            { type: 'image', url: ExImg100 },
            { type: 'image', url: ExImg101 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['JS', 'CSS', 'HTML'],
        url: 'https://isavuconazol.vercel.app/',
    },
    {
        id: 29,
        name: 'Elearning IO Academy Training',
        slug: '29',
        category: 'desarrollos web',
        description: 'Experiencia interactiva enfocada en contenido farmacéutico y educativo sobre Isavuconazol, presentada mediante recursos visuales y navegación dinámica.',
        images: [
            { type: 'video', url: Gif29 },
            { type: 'image', url: ExImg102 },
            { type: 'image', url: ExImg103 },
            { type: 'image', url: ExImg104 },
            { type: 'image', url: ExImg105 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['React', 'Vue', 'CSS', 'HTML', 'Tailwind CSS'],
        url: 'https://io-academy-training.eml.com.co/',
    },
    {
        id: 30,
        name: 'Training Academy Game',
        slug: '30',
        category: 'videojuegos',
        description: 'Juego interactivo de entrenamiento diseñado para reforzar conocimientos mediante dinámicas, retos y experiencias gamificadas.',
        images: [
            { type: 'video', url: Gif30 },
            { type: 'image', url: ExImg106 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['React', 'Vite', 'HTML', 'Tailwind CSS'],
        url: 'https://eml.com.co/Juego_training_academy/index.html',
    },
    {
        id: 31,
        name: 'Immuno Oncology',
        slug: '31',
        category: 'videojuegos',
        description: 'Plataforma interactiva enfocada en inmuno-oncología, diseñada para brindar contenido educativo y experiencias digitales relacionadas con tratamientos y avances médicos.',
        images: [
            { type: 'video', url: Gif31 },
            { type: 'image', url: ExImg107 },
            { type: 'image', url: ExImg108 },
            { type: 'image', url: ExImg109 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['Vue', 'HTML', 'Tailwind CSS'],
        url: 'https://immuno-oncology.eml.com.co/',
    },
    {
        id: 32,
        name: 'Juego Ruleta Interactiva',
        slug: '32',
        category: 'videojuegos',
        description: 'Aplicación interactiva tipo ruleta diseñada para dinámicas, actividades gamificadas y experiencias de participación digital.',
        images: [
            { type: 'video', url: Gif32 },
            { type: 'image', url: ExImg110 },
            { type: 'image', url: ExImg111 },
            { type: 'image', url: ExImg112 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['CSS', 'HTML', 'JS'],
        url: 'https://juego-ruleta.vercel.app/',
    },
    {
        id: 33,
        name: 'Juego Marcianos - Organiza',
        slug: '33',
        category: 'videojuegos',
        description: 'Juego interactivo de lógica y organización con temática espacial, diseñado para aprender y entretener mediante dinámicas visuales y desafíos.',
        images: [
            { type: 'video', url: Gif33 },
            { type: 'image', url: ExImg113 },
            { type: 'image', url: ExImg114 },
            { type: 'image', url: ExImg115 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['CSS', 'HTML', 'JS'],
        url: 'https://eml.com.co/juego_marcianos/juego-organiza.html',
    },
    {
        id: 34,
        name: 'Praxis Pharmaceutical',
        slug: '34',
        category: 'desarrollos web',
        description: 'Sitio corporativo del sector farmacéutico enfocado en soluciones, productos y servicios relacionados con la industria de la salud y el bienestar.',
        images: [
            { type: 'video', url: Gif34 },
            { type: 'image', url: ExImg116 },
            { type: 'image', url: ExImg117 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['React', 'Tailwind CSS', 'Vite'],
        url: 'https://praxispharmaceutical.com.co/',
    },
    {
        id: 35,
        name: 'Trivia Ronda Relámpago',
        slug: '35',
        category: 'Desarrollos moviles',
        description: 'Juego de trivia interactivo diseñado para evaluar conocimientos mediante preguntas rápidas, retos dinámicos y experiencias gamificadas.',
        images: [
            { type: 'video', url: Gif35 },
            { type: 'image', url: ExImg118 },
            { type: 'image', url: ExImg119 },
            { type: 'image', url: ExImg120 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['React', 'Tailwind CSS', 'Vite'],
        url: 'http://triviarondarelampago.eml.com.co/login',
    },
    {
        id: 36,
        name: 'Penalty Game',
        slug: '36',
        category: 'Desarrollos moviles',
        description: 'Juego interactivo tipo penalti diseñado para ofrecer una experiencia dinámica y entretenida mediante mecánicas deportivas y gamificación.',
        images: [
            { type: 'video', url: Gif36 },
            { type: 'image', url: ExImg121 },
            { type: 'image', url: ExImg122 },
            { type: 'image', url: ExImg123 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['React', 'Tailwind CSS', 'Vite'],
        url: 'https://penalty.eml.com.co/',
    },
    {
        id: 37,
        name: 'Sospechar EML',
        slug: '37',
        category: 'videojuegos',
        description: 'Plataforma interactiva orientada a la concientización y educación médica mediante contenido dinámico y experiencias digitales informativas.',
        images: [
            { type: 'video', url: Gif37 },
            { type: 'image', url: ExImg124 },
            { type: 'image', url: ExImg125 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['React', 'Tailwind CSS'],
        url: 'https://sospechar-eml.eml.com.co/',
    },
    {
        id: 38,
        name: 'Rompecabezas Interactivo',
        slug: '38',
        category: 'videojuegos',
        description: 'El jugador tiene que poner las piezas de manera correcta para poder obtener  la solución, un puzle tiene diferentes piezas que hay que unir, cada pieza tiene una pequeña parte de un dibujo que aparece cuando todas las piezas están correctamente unidas. Características: Rompecabezas de imágenes  Debes encontrar el patron  Es  un muy divertido resolver, solo tienes que subir la imagenes . 15 deslizantes ',
        images: [
            { type: 'video', url: Gif38 },
            { type: 'image', url: ExImg126 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['React', 'CSS'],
        url: 'https://rompecabezas.eml.com.co/',
    },
    {
        id: 39,
        name: 'Juego Memory Portafolio',
        slug: '39',
        category: 'videojuegos',
        description: 'Juego de memoria interactivo diseñado para reforzar conocimientos y estimular la concentración mediante dinámicas visuales y gamificación.',
        images: [
            { type: 'video', url: Gif39 },
            { type: 'image', url: ExImg127 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['HTML', 'CSS', 'JS'],
        url: 'https://juegos-portafolio.eml.com.co/memory/index.html',
    },
    {
        id: 40,
        name: 'Face Quiz AI',
        slug: '40',
        category: 'Juegos de IA',
        description: 'Vive una experiencia interactiva impulsada por inteligencia artificial, donde cada movimiento de tu rostro activa una respuesta diferente. Toca distintas partes de la cara para descubrir nuevas interacciones y gira la cabeza diciendo “no” para cambiar de pregunta y continuar el desafío. Una forma divertida e innovadora de jugar usando tus expresiones y movimientos en tiempo real.',
        images: [
            { type: 'video', url: Gif40 },
            { type: 'image', url: ExImg128 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['HTML', 'JS'],
        url: 'https://face-quiz-ai.vercel.app/',
    },
    {
        id: 41,
        name: 'Espejo Mágico',
        slug: '41',
        category: 'Juegos de IA',
        description: 'Adéntrate en una experiencia interactiva impulsada por inteligencia artificial, donde tus movimientos y expresiones cobran vida frente al espejo mágico. Atrapa estrellas moviendo la cabeza, desbloquea nuevos niveles y desafía tus reflejos en un mundo lleno de magia, diversión y aventuras en tiempo real.',
        images: [
            { type: 'video', url: Gif41 },
            { type: 'image', url: ExImg129 },
        ],
        platform: ['Web', 'Android', 'iOS'],
        language: ['HTML', 'JS'],
        url: 'https://espejo-magico.vercel.app/',
    },
]